export default __webpack_public_path__ + "assets/images/dbbdd85c8b621dbf5af5ad456e9de655.png";